/* eslint-disable import/prefer-default-export */
/* Draft Kit */
export const GO_DRAFT_KIT = 'draft/ALL';
export const GO_RANKINGS = 'draft/RANKINGS';
export const GO_CHEAT_SHEETS = 'draft/CHEAT_SHEETS';
export const GO_SLEEPERS = 'draft/SLEEPERS';
export const GO_PLAYER_INJURY_REPORTS = 'draft/PLAYER_INJURY_REPORTS';
export const GO_AVERAGE_DRAFT_POSITIONS = 'draft/AVERAGE_DRAFT_POSITIONS';
export const GO_DRAFTING_STRATEGY = 'draft/DRAFTING_STRATEGY';
export const GO_TOOLS = 'draft/TOOLS';
export const GO_INDIVIDUAL_DEFENSIVE_PLAYERS = 'draft/INDIVIDUAL_DEFENSIVE_PLAYERS';
export const GO_AUCTION_LEAGUES = 'draft/AUCTION_LEAGUES';
/* Teams, In Season, Stats */
export const GO_TEAMS = 'teams/ALL';
export const PREDICTIONS = 'season/PREDICTIONS';
export const GO_STATS = 'stats/ALL';
export const GO_WEEKLY = 'weekly/STATS';
export const GO_GAME_SCANS = 'stats/GAME_SCANS';
export const GO_TEAM_POSITION_RANKINGS = 'stats/TEAM_POSITION_RANKINGS';
export const GO_STRENGTH_OF_SCHEDULE = 'stats/STRENGTH_OF_SCHEDULE';
export const GO_TEAM_POSITION_RANK_MATCHUPS = 'stats/TEAM_POSITION_RANK_MATCHUPS';
export const GO_GAME_STATISTICS_MATCHUPS = 'stats/GAME_MATCHUPS';
export const GO_TEAM_STATISTICS = 'stats/TEAM_STATISTICS';
/* Resources */
export const GO_RESOURCES = 'resources/ALL';
export const GO_DEPTH_CHARTS = 'resources/DEPTH_CHARTS';
export const GO_NFL_SCHEDULE_GRID = 'resources/NFL_SCHEDULE_GRID';
export const GO_NFL_SCHEDULE_WEEKLY_GRID = 'resources/NFL_SCHEDULE_WEEKLY_GRID';
export const GO_NFL_FULL_WEEKLY_SCHEDULE = 'resources/NFL_FULL_WEEKLY_SCHEDULE';
export const GO_NFL_DRAFT = 'resources/NFL_DRAFT';
export const GO_NFL_CALENDAR = 'resources/NFL_CALENDAR';
export const GO_NEWSLETTER_SIGNUP = 'resources/NEWSLETTER_SIGNUP';
/* MyHuddle */
export const GO_PLAYER_SEARCH = 'myhuddle/PLAYER_SEARCH';
export const GO_PAYMENT_INFORMATION = 'myhuddle/PAYMENT_INFORMATION';

/* eslint-enable import/prefer-default-export */



// WEBPACK FOOTER //
// ./src/store/actions/aktaryTechPlaceholder.types.js